import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {LazyLoadImage} from "react-lazy-load-image-component";
import img01 from "../../../images/location_new/logo-1.webp";
import img02 from "../../../images/location_new/logo-3.webp";
import img03 from "../../../images/location_new/logo-2.webp";
import img04 from "../../../images/location_new/logo-4.webp";
import img05 from "../../../images/location_new/logo-5.webp";
import img06 from "../../../images/location_new/logo-6.webp";

import {Link} from 'gatsby';


const Awards = [
    {
        logo: img01,
        title: 'Horizon Interactive Awards - Gold Winner',
        description: "We're a gold winner. Recognized for our focus on digital design and interactive apps.",
    },
    {
        logo: img02,
        title: 'Clutch Award 2021',
        description: "Clutch is recognized as one of the top B2B companies. Cultivating change all around.",
    },
    {
        logo: img03,
        title: 'App for Golf Community',
        description: "TeeMates, an app curated for golf enthusiasts, won the Platinum Award in the sports ecosystem.",
    },
    {
        logo: img04,
        title: 'Top Mobile App Developers',
        description: "Development. Code. Results. We’re known for the quality we deliver.",
    },
    {
        logo: img05,
        title: 'Expertise 2020',
        description: "On to new horizons. Leading the pathway to change for the mobile app development ecosystem.",
    },
    {
        logo: img06,
        title: 'Top Rated Softwareworld',
        description: "We're at the top. Rated among the best. Doing beyond the ordinary.",
    },

];

function Awardshonors(props) {
    return (
        <div className="section_awards p-100 tekrevol_gray_bg">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={12} xl={10} xxl={10} className="m-auto text-center">
                        <div className="example center text-center" data-text="Awards">
                            <h2>Awards & Honors</h2>
                        </div>
                        <p>Peek into Awards and Honors at TekRevol – our way of showcasing the excellence that defines us. It's more than recognition; it's a testament to our commitment to your success.</p>
                        <div className="start">
                            <svg xmlns="http://www.w3.org/2000/svg" width="241" height="41" viewBox="0 0 241 41"
                                 fill="none">
                                <path
                                    d="M20.4608 0.682373L24.9511 14.502L39.4819 14.502L27.7262 23.043L32.2165 36.8625L20.4608 28.3216L8.70519 36.8625L13.1954 23.043L1.4398 14.502L15.9706 14.502L20.4608 0.682373Z"
                                    fill="#FFA800"/>
                                <path
                                    d="M70.4608 0.682617L74.9511 14.5022L89.4819 14.5022L77.7262 23.0432L82.2165 36.8628L70.4608 28.3218L58.7052 36.8628L63.1954 23.0432L51.4398 14.5022L65.9706 14.5022L70.4608 0.682617Z"
                                    fill="#FFA800"/>
                                <path
                                    d="M120.461 0.682617L124.951 14.5022L139.482 14.5022L127.726 23.0432L132.216 36.8628L120.461 28.3218L108.705 36.8628L113.195 23.0432L101.44 14.5022L115.971 14.5022L120.461 0.682617Z"
                                    fill="#FFA800"/>
                                <path
                                    d="M170.461 0.682617L174.951 14.5022L189.482 14.5022L177.726 23.0432L182.216 36.8628L170.461 28.3218L158.705 36.8628L163.195 23.0432L151.44 14.5022L165.971 14.5022L170.461 0.682617Z"
                                    fill="#FFA800"/>
                                <path
                                    d="M220.461 0.682617L224.951 14.5022L239.482 14.5022L227.726 23.0432L232.216 36.8628L220.461 28.3218L208.705 36.8628L213.195 23.0432L201.44 14.5022L215.971 14.5022L220.461 0.682617Z"
                                    fill="#FFA800"/>
                            </svg>
                            <ul className="rating">
                                <li><span>50</span> Reviews</li>
                                <li><span>4.9</span> Rating</li>
                            </ul>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="m-auto text-center">
                        <div className="awards_listing">
                            {Awards.map((item, index) => (
                                <div className="awards_boxing" key={index}>
                                    <div className="awards_logo">
                                        <LazyLoadImage
                                            src={item.logo}
                                            effect="blur"
                                            alt={item.title}
                                            className="img-fluid"
                                        />
                                    </div>
                                    <div className="awards_txt">
                                        <h4>{item.title}</h4>
                                        <p>{item.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="btn_more">
                            <Link to="https://clutch.co/profile/tekrevol" rel="noopener"  className="border_btn" aria-label="TekRevol Contact">Check Reviews</Link>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Awardshonors;